module.exports = __webpack_public_path__ + "img/award.599a10a2.svg";